import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/content-creator/layout.tsx")